/**
 * @generated SignedSource<<3b5b2f4f575bfa8ab605a5d48f240413>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePersonalizedEmailTemplateInput = {
  clientMutationId?: string | null;
  data: PersonalizedEmailTemplateInput;
  id: string;
};
export type PersonalizedEmailTemplateInput = {
  body: string;
  key: string;
  previewText: string;
  subject: string;
  variables: ReadonlyArray<string>;
};
export type emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation$variables = {
  input: UpdatePersonalizedEmailTemplateInput;
};
export type emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation$data = {
  readonly Admin: {
    readonly Email: {
      readonly updatePersonalizedEmailTemplate: {
        readonly data: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"emailTemplateEdit_EmailTemplateFragment">;
          };
        };
      } | null;
    };
  };
};
export type emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation = {
  response: emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation$data;
  variables: emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UpdatePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "updatePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedEmailTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedEmailTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "emailTemplateEdit_EmailTemplateFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UpdatePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "updatePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedEmailTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedEmailTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmailTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "key",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previewText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "variables",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45f7315555182747d7bba74b8a5f91fe",
    "id": null,
    "metadata": {},
    "name": "emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation emailTemplateEdit_UpdatePersonalizedEmailTemplateMutation(\n  $input: UpdatePersonalizedEmailTemplateInput!\n) {\n  Admin {\n    Email {\n      updatePersonalizedEmailTemplate(input: $input) {\n        data {\n          node {\n            ...emailTemplateEdit_EmailTemplateFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment emailTemplateEdit_EmailTemplateFragment on PersonalizedEmailTemplate {\n  id\n  template {\n    key\n    subject\n    previewText\n    body\n    variables\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ae49df9f525f976cad1f4353d0373ef";

export default node;
